import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  isTradeAlarmEnabled,
  setTradeAlarmEnabled,
  unlockTradeAlarm,
} from '../../utils/alarmService';

const topLinks = [
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'ACCE', path: '/acce' },
  { label: 'ARGOS', path: '/argos' },
  { label: 'GEMIC', path: '/gemic' },
  { label: 'MEIC', path: '/meic' },
  { label: 'Market Intelligence', path: '/market-intelligence' },
];

export default function TopNav() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [alarmEnabled, setAlarmEnabled] = useState(isTradeAlarmEnabled());

  const closeMobileNav = () => {
    setMobileNavOpen(false);
  };

  const handleAlarmToggle = async () => {
    const nextValue = !alarmEnabled;

    if (nextValue) {
      const unlocked = await unlockTradeAlarm();

      if (!unlocked) {
        alert(
          'Your browser blocked audio alerts. Click the page and try enabling alerts again.'
        );
        return;
      }
    }

    setTradeAlarmEnabled(nextValue);
    setAlarmEnabled(nextValue);
  };

  return (
    <header className="topNav">
      <div className="topBrand">
        <div className="spxNavLogoBox">
          <img
            src="/logo192.png"
            alt="SPX Gamma Logo"
            className="spxNavLogoImg"
          />
        </div>

        <div>
          <div className="brandTitle">SPX GAMMA</div>
          <div className="brandSubtitle">PREMIUM SELLERS DASHBOARD</div>
        </div>
      </div>

      <button
        className="topNavMenuButton"
        onClick={() => setMobileNavOpen((prev) => !prev)}
        aria-label="Open navigation"
        type="button"
      >
        ☰
      </button>

      <nav className={mobileNavOpen ? 'topTabs mobileNavOpen' : 'topTabs'}>
        {topLinks.map((link) => (
          <NavLink
            key={link.label}
            to={link.path}
            onClick={closeMobileNav}
            className={({ isActive }) =>
              isActive ? 'topTab active' : 'topTab'
            }
          >
            {link.label}
          </NavLink>
        ))}
      </nav>

      <div className="topTools">
        <button
          className={alarmEnabled ? 'iconButton alarmEnabled' : 'iconButton'}
          type="button"
          onClick={handleAlarmToggle}
          title={alarmEnabled ? 'Trade alarms enabled' : 'Enable trade alarms'}
          aria-label={
            alarmEnabled ? 'Disable trade alarms' : 'Enable trade alarms'
          }
        >
          {alarmEnabled ? '🔔' : '🔕'}
        </button>
      </div>
    </header>
  );
}